/* eslint-disable i18n/no-russian-character */
const ruSystem = {
    connection: {
        isOfflineConfirm: "Интернет-соединение не обнаружено. Всё равно перейти по ссылке?",
        offlineRegime: "Оффлайн режим",
    },
    data: {
        errors: {
            forbidden: "Действие запрещено",
            network: "Нет соединения с сервером",
            timeout: "Превышено время ожидания ответа",
            abort: "Запрос прерван",
        },
    },
    serviceWorker: {
        update: "Доступна новая версия портала. Обновимся?",
    },
    dateTime: {
        errors: {
            invalidDate: "Неверная дата",
            endDateBeforeStartDate: "Дата окончания не может быть раньше даты начала",
        },
        duration: {
            year: "г.",
            month: "мес.",
            day: "д.",
            hour: "ч.",
            minute: "м.",
            second: "с.",
        },
    },
    biometric: {
        error: "❌ Ошибка биометрической аутентификации",
    },
};

export default ruSystem;
